<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { initialsFromText } from '@client/utils/users';

  import { generateUUID } from '@common/utils/strings';

  export let data = {};
  export let type = '';
  export let nameField = 'name';
  export let countField = 'directMembersCount';

  const sortKey = Array.isArray(nameField) ? nameField[0] : nameField;

  // One stable id per component instance; per-avatar ids derive from it + index
  // so they don't change across re-renders (sveltestrap caches the tooltip target).
  const instanceId = generateUUID();

  $: excludedTag = $format('label.EXCLUDED_TAG');
  $: items = data[type].sort((a, b) =>
    !!a.excluded === !!b.excluded ? a[sortKey]?.localeCompare(b[sortKey]) ?? 0 : a.excluded ? 1 : -1
  );
</script>

<div class="assigned-groups" class:single={items.length === 1}>
  <ul>
    {#each items.slice(0, 6) as item, index}
      {@const name = Array.isArray(nameField) ? nameField.map((value) => item[value]).join(' ') : item[nameField]}
      {@const id = `${instanceId}-${index}`}

      {#if index <= Math.min(4, items.length - 1)}
        <li {id} class:excluded={item.excluded}>
          <span>{initialsFromText(name)}</span>
        </li>
        <Tooltip target={id} placement="top">
          {name}

          {#if item[countField]}
            ({item[countField]})
          {/if}
          {#if item.excluded}
            - {excludedTag}
          {/if}
        </Tooltip>
      {:else}
        <li class="more" id="{id}-more">
          <span>+{items.length - index}</span>
        </li>
        <Tooltip target="{id}-more" placement="top">
          {@html items
            .map(
              (i) =>
                i[nameField] + (i[countField] ? ` (${i[countField]})` : '') + (i.excluded ? ` - ${excludedTag}` : '')
            )
            .slice(index)
            .join('<br>')}
        </Tooltip>
      {/if}
    {/each}
  </ul>
</div>

<style lang="scss" src="./portholes.scss"></style>
